export default __webpack_public_path__ + "static/media/intro-database.b4048b15.jpg";